import { useCallback, useRef, useState } from 'react';
import { Button, Form, Input, Radio, RadioGroup, Schema } from 'rsuite';
import TextField from '../../components/form/textfield';
import Field from '../../components/form/field';
import { showToast } from '../../utils/toast';
import { sendFeedback } from '../../core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const { StringType } = Schema.Types;
const model = Schema.Model({
  // first_q: StringType('فرمت صحیح نیست!').isRequired('الزامی است!'),
  // second_q: StringType('فرمت صحیح نیست!').isRequired('الزامی است!'),
  // third_q: StringType('فرمت صحیح نیست!').isRequired('الزامی است!'),
  forth_q: StringType('فرمت صحیح نیست!').isRequired('الزامی است!'),
  fifth_q: StringType('فرمت صحیح نیست!').isRequired('الزامی است!')
});
export const Feedback = () => {
  const [isUsed, setIsUsed] = useState(1);
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formRef = useRef<any>(null);
  const [formError, setFormError] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValue, setFormValue] = useState<any>({});
  const handleSubmit = useCallback(async () => {
    if (formRef.current && !formRef.current.check()) {
      console.log('formError', formError);
      return;
    }
    if (formValue.first_q === 1 && !formValue.second_q) {
      setFormError((pre) => {
        return { ...pre, second_q: 'الزامی است!' };
      });
    }
    if (formValue.first_q === 0 && !formValue.third_q) {
      setFormError((pre) => {
        return { ...pre, third_q: 'الزامی است!' };
      });
    }
    setLoading(true);
    try {
      const { status, data } = await sendFeedback({
        ...formValue,
        second_q: formValue.first_q === 1 ? formValue.second_q : null,
        third_q: formValue.first_q === 0 ? formValue.third_q : null
      });
      if (status === 200) {
        console.log(data);
        showToast(data?.message, 'success');
      } else {
        showToast('مشکلی پیش آمده!', 'error');
      }
    } catch (e) {
      showToast('مشکلی پیش آمده!', 'error');
      console.log(e);
    }
    console.log('submitted', formValue);
    setLoading(false);
    // return;
  }, [formError, formValue]);
  return (
    <div
      className="relative"
      style={{
        minHeight: '100%',
        backgroundImage: 'url("../images/abstract_bg_white.svg")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}>
      <div
        style={{
          background:
            'linear-gradient(to bottom, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, .85) 100%)',
          height: '100%'
        }}
        className=" px-3 py-3 text-justify">
        <Form
          ref={formRef}
          onChange={setFormValue}
          onCheck={setFormError}
          formError={formError}
          model={model}
          onSubmit={handleSubmit}
          className="w-full pb-3">
          از اينکه برنامه MedMe را برای پایش سلامت خودتون انتخاب کردین سپاس گزاریم. تیم تحقیق و
          توسعه اپلیکیشن MedMe برای بهبود کیفیت و کارایی خدماتی که ارایه می دهد نیازمند نظر شما
          عزیزان استفاده کننده از برنامه می باشد و خوشحال خواهیم شد که نظرات سازنده و صمیمانه خود را
          در مورد روند برنامه با تیم سازنده درمیان بگذارید. لطفا در ادامه به سوالات نظر سنجی طبق
          تجربه خود پاسخ دهید.
          <br />
          <div className="text-sm mt-4">
            <Field
              dir="rtl"
              name="first_q"
              accepter={RadioGroup}
              value={isUsed}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onChange={(value: any) => setIsUsed(value)}
              defaultValue={1}
              label="آیا هنوز از خدمات معاینه هوشمند برنامه استفاده کرده اید؟">
              <Radio value={1}>بله از معاینه هوشمند استفاده کرده ام.</Radio>
              <Radio value={0}>خیر تا کنون استفاده نکرده ام ولی قصد دارم از آن استفاده کنم.</Radio>
            </Field>
            {isUsed === 1 ? (
              <div>
                خوشحالیم که از معاینه هوشمند این برنامه استفاده کرده اید. آیا روند معاینه برای شما
                جذابیت داشت؟ آیا سوالات به گونه ای بود که بتواند شرح حال دقیقی از بیماری شما بگیرد؟
                آیا تشخیصی که هوش نوعی برای شما گذاشت با نظر پزشک شما همخوانی داشت؟ لطفا در رابطه با
                این موارد نظر خود را در کادر زیر بنویسید.
                <TextField
                  accepter={Input}
                  type="text"
                  name="second_q"
                  label="نظر خود را در اینجا بنویسید."
                  placeholder=""
                  dir="rtl"
                />
              </div>
            ) : (
              <div>
                چه چیزی باعث شده است تا کنون از خدمات معاینه هوشمند استفاده نکنید؟ در کادر زیر
                بنویسید. آیا هزینه ویزیت هوشمند باعث شده تا از این امکان استفاده نکنید یا از تشخیصی
                که هوش مصنوعی برای شما خواهد گذاشت نگران هستید؟ یا اینکه ترجیح می دهید حضوری با یک
                پزشک در ارتباط باشید؟ لطفا نظر خود را با ما در میان بگذارید.
                <TextField
                  accepter={Input}
                  type="text"
                  name="third_q"
                  label="نظر خود را در اینجا بنویسید."
                  placeholder=""
                  dir="rtl"
                />
              </div>
            )}
            <br />
            <div>
              به نظر شما چه خدمات دیگری بهتر بود که در اين برنامه به شما ارایه میشد؟ مثلا آیا اگر
              گرفتن ویزیت حضوری پزشک از طریق این برنامه فراهم شود. این خدمت میتواند نیاز شما را
              برآورده کند؟ امکانات دیگری را که دوست دارید در اين برنامه ببینید را برای ما بنویسید.
              <TextField
                accepter={Input}
                type="text"
                name="forth_q"
                label="نظر خود را در اینجا بنویسید."
                placeholder=""
                dir="rtl"
              />
            </div>
            <br />
            <div>
              در مورد تغییرات دیگری دیگری که دوست دارید در اين برنامه انجام شود نیز تیم توسعه را
              یاری دهید، مثلا تغییرات ظاهری يا تغییر در نحوه چیدمان قسمت های مختلف برنامه. نظر
              خودتون را با تیم توسعه در میان بگذارید
              <TextField
                accepter={Input}
                type="text"
                name="fifth_q"
                label="نظر خود را در اینجا بنویسید."
                placeholder=""
                dir="rtl"
              />
            </div>
          </div>
          <div className="flex justify-center">
            <Button
              appearance="primary"
              className="w-[30%] mt-5 btn-outline"
              type="submit"
              loading={loading}>
              ارسال نظر
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};
